import { securePayment, orderSummaryGifts} from '@/assets';

interface OrderSummaryProps {
  flowType: 'one-off' | 'subscription';
  stepData?: any;
  showSecure?: boolean;
}

export function OrderSummary({ flowType, stepData, showSecure = true }: OrderSummaryProps) {
  const isSubscription = flowType === 'subscription';
  const recipients = isSubscription ? [] : stepData?.step1?.recipients || [];
  const recipient = isSubscription ? stepData?.step1?.recipient : null;
  const recipientCount = isSubscription ? 1 : recipients.length;

  // Pricing logic based on wireframes
  const pricePerRecipient = 50; // $50 per recipient for one-off
  const subscriptionPrice = 250; // Flat $250 for subscription
  const totalPrice = isSubscription ? subscriptionPrice : pricePerRecipient * recipientCount;

  return (
    <div className="order-summary bg-white/90 backdrop-blur-sm rounded-3xl shadow-soft h-fit pb-8">
      <div className={`order-summary-header`}>
        <img src={orderSummaryGifts} className='w-full h-full' />
      </div>
      
      <div className="text-center p-8">
        <h3 className="text-lg font-semibold text-purple-medium">
          {isSubscription
            ? `Subscription for one year to Birdie Gifts ${stepData?.step1?.events?.filter((event: any) => event.date)?.length ? `for ${stepData.step1.events.filter((event: any) => event.date).length} events per year for:` : ''}`
            : 'Personalized Gift Recommendation for:'}
        </h3>
        {isSubscription &&  <p className="text-xl font-bold text-[#444444]">
          {<strong>{`${recipient?.name || 'Recipient name'}`}</strong>}
        </p>}
      
      </div>

      {/* Events List for Subscription */}
      {isSubscription && (
        <div className="space-y-2 mb-6 flex flex-col items-center">
          {stepData?.step1?.events
            ?.filter((event: any) => event.date)
            ?.slice(0, 6)
            .map((event: any, index: number) => (
              <div key={index} className="bg-purple-dark text-white px-6 py-3 rounded-3xl text-[16px] leading-[1.2] font-bold">
                {event.occasion} - {new Date(event.date).toLocaleDateString()}
              </div>
            ))}
        </div>
      )}

      {/* Recipients List for One-off */}
      {!isSubscription && (
        <div className="space-y-2 mb-6 flex flex-col items-center">
          {recipients.map((recipient: any, index: number) => (
            <div
              key={index}
              className="bg-purple-dark text-white px-6 py-3 rounded-3xl text-[16px] leading-[1.2] font-bold"
            >
              {recipient.name}
            </div>
          ))}
        </div>
      )}

      <hr className="border-gray-300 my-6" />

      {/* Pricing */}
      <div className="text-center">
        <div className="text-4xl font-bold text-[#444444] mb-2">
          ${totalPrice} <span className="text-lg font-normal">USD</span>
        </div>
        <div className="text-sm text-green-medium">
          {isSubscription ? '' : `$${pricePerRecipient} usd per recipient`}
        </div>

        {showSecure && (
          <div className="absolute right-0 bottom-[50px] md:bottom-[-55px]">
            <img src={securePayment} alt="Secure Payment" className="w-[102px] h-[37px]" />
          </div>
        )}
      </div>
    </div>
  );
}
